import gql from 'graphql-tag'
import React from 'react'
import {
  ChartContainer,
  ChartDataLoader,
  ChartHeading,
  Graph,
  lineRenderer,
  useACTheme,
} from 'admin-web-ui'
import { useQuery } from '@apollo/client'

export const QUERY = gql`
  query {
    reports {
      totalSudosActive
    }
  }
`

export const TotalSudosActive: React.FC = () => {
  const dataResult = useQuery(QUERY)
  const theme = useACTheme()

  return (
    <ChartContainer>
      <ChartHeading
        heading="Total Sudos Active by Day"
        subHeading="Collected over the last 30 days"
      />
      <ChartDataLoader
        dataResult={dataResult}
        dataPath="reports.totalSudosActive"
      >
        {(chartData) => (
          <Graph
            renderer={lineRenderer}
            chartData={chartData}
            dataSetProps={{
              sudos: {
                label: 'Sudos',
                color: theme.colors.sudoBlue,
              },
            }}
          />
        )}
      </ChartDataLoader>
    </ChartContainer>
  )
}
